import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FilterLeistungSearchPipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'filterLeistungSearch',
})
export class FilterLeistungSearchPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: any[], searchInput:string) {
    //return true;

     if (searchInput && searchInput.trim() != '') {
      return value.filter(item => 
      	item.KundeName.toLowerCase().indexOf(searchInput.toLowerCase()) > -1 || 
      	item.MitarbeiterName.toLowerCase().indexOf(searchInput.toLowerCase()) > -1 || 
      	item.Datum.toLowerCase().indexOf(searchInput.toLowerCase()) > -1 || 
      	item.ProjektBezeichnung.toLowerCase().indexOf(searchInput.toLowerCase()) > -1
      	);
    }else{
    	return value;
    }

  }
}



// WEBPACK FOOTER //
// ./src/pipes/filter-leistung-search/filter-leistung-search.ts